export interface ISearchOptions {
    searchQuery: string;
    searchInMeetings: boolean;
    searchInArchives: boolean;
    searchInBoards: boolean;
    searchTitlesOnly: boolean;
    searchInDoc: boolean
}

export interface ISearchPageDto
{
    results: ISearchResult[];
    count: number;
}
export interface ISearchResult
{
    title: string;
    caption: string;
    link: string;
    scope:string;
    meetingTitle: string;
    startMeeting: string;
    archiveTitle: string;
    sourceId: number;
    contentId: number;
    numberPage: number; 
    fileId: number; //  serve per le presentazioni
    nodeId: number; 
    languageId: number;
    typology: number; // serve per la descriminante archivio file non convertibili con zip

}


var ScopeType = {
    ODG: "ODG",
    DOC: "DOC",
    BOARD: "BOARD",
    ARCHIVE: "ARCHIVE",
  };
  
  export default ScopeType;